import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ClassTeacherService from "../../services/classteacher.services";

export const getClassteacher = createAsyncThunk(
  "Classteacher/getClassteacher",
  async (item, thunkAPI) => {
    try {
      const response = await ClassTeacherService.getclassteacher(item);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);


export const addClassteacher = createAsyncThunk(
  "classteacher/addClassteacher",
  async (data, thunkAPI) => {
    try {
      const response = await ClassTeacherService.addclassteacher(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);


export const updateClassteacher = createAsyncThunk(
  "classteacher/updateClassteacher",
  async (payload, thunkAPI) => {
    try {
      const response = await ClassTeacherService.editclassteacher(payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const deleteClassteacher = createAsyncThunk(
  "classteacher/deleteClassteacher",
  async (id, thunkAPI) => {
    try {
      const response = await ClassTeacherService.deleteclassteacher(id);
      return id; 
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);


const initialState = {
  loading: false,
  error: null,
  classteacherlist: [],
};


const classteacherSlice = createSlice({
  name: "classteacher",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(getClassteacher.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(getClassteacher.fulfilled, (state, action) => {
        state.loading = false;
        state.classteacherlist = action.payload?.data || [];
      })

      .addCase(getClassteacher.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default classteacherSlice.reducer;
